module.exports = __webpack_public_path__ + "static/media/RightArrow.01ea7ecf.svg";